import { FC } from 'react';
import { Paper, PaperProps } from '@mui/material';

export interface IFormStepGreySectionProps extends PaperProps {}

export const FormStepGreySection: FC<IFormStepGreySectionProps> = ({ sx, children, ...props }) => {
	return (
		<Paper
			elevation={0}
			sx={{ backgroundColor: 'grey.100', padding: 3, borderRadius: 2, marginX: -3, marginTop: 4.5, ...sx }}
			{...props}
		>
			{children}
		</Paper>
	);
};
